import { GuardedDeletionService } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { PropertyService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  PropertyCreateDto,
  PropertyDto,
  PropertyExcelDownloadDto,
  PropertyUpdateDto,
} from '../proxy/planning/dtos/property';
import { PROPERTY_CONFIG, PROPERTY_FIELDS } from './property.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-property',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PropertyService, ConfirmationService],
  templateUrl: './property.html',
  styleUrl: './property.scss',
})
export class Property extends BaseHierarchicalCrudComponent<
  PropertyDto,
  PropertyCreateDto,
  PropertyUpdateDto,
  PropertyExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PropertyService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('Property', ids),
  };
  config = PROPERTY_CONFIG;
  fields = PROPERTY_FIELDS;

  protected prepareUpdateDto(data: any, selected: PropertyDto): PropertyUpdateDto {
    return {
      name: data.name,
      propertyCode: data.propertyCode,
      internalOrderId: data.internalOrderId,
      fomentContractId: data.fomentContractId,
      commercialAgentId: data.commercialAgentId,
      remsoft: data.remsoft,
      isDisabled: data.isDisabled,
      transportAccessTypeId: data.transportAccessTypeId,
      seasonTypeId: data.seasonTypeId,
      zoneId: data.zoneId,
      millId: data.millId,
      strategicCommercialZoneId: data.strategicCommercialZoneId,
      locationId: data.locationId,
      vendorId: data.vendorId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Property';
  }
}
